__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "video-room-component";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@microsoft/applicationinsights-react-js", "19.3.7", function() { return Promise.all([__webpack_require__.e(132), __webpack_require__.e(950), __webpack_require__.e(460)]).then(function() { return function() { return __webpack_require__(2460); }; }); });
			register("@microsoft/applicationinsights-web", "3.3.9", function() { return Promise.all([__webpack_require__.e(132), __webpack_require__.e(473)]).then(function() { return function() { return __webpack_require__(56473); }; }); });
			register("@twilio/video-processors", "1.0.2", function() { return Promise.all([__webpack_require__.e(691), __webpack_require__.e(660), __webpack_require__.e(935), __webpack_require__.e(371)]).then(function() { return function() { return __webpack_require__(29660); }; }); });
			register("axios", "0.24.0", function() { return __webpack_require__.e(569).then(function() { return function() { return __webpack_require__(74569); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(950), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(54164); }; }); });
			register("react-router-dom", "6.2.1", function() { return Promise.all([__webpack_require__.e(677), __webpack_require__.e(950), __webpack_require__.e(901)]).then(function() { return function() { return __webpack_require__(16677); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(72791); }; }); });
			register("styled-components", "5.3.3", function() { return Promise.all([__webpack_require__.e(751), __webpack_require__.e(950)]).then(function() { return function() { return __webpack_require__(15751); }; }); });
			register("twilio-video", "2.30.0", function() { return __webpack_require__.e(478).then(function() { return function() { return __webpack_require__(22478); }; }); });
			register("web-vitals", "2.1.4", function() { return __webpack_require__.e(787).then(function() { return function() { return __webpack_require__(787); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};